import { render, staticRenderFns } from "./Delegates.vue?vue&type=template&id=6d9b4200&scoped=true&"
import script from "./Delegates.vue?vue&type=script&lang=ts&"
export * from "./Delegates.vue?vue&type=script&lang=ts&"
import style0 from "./Delegates.vue?vue&type=style&index=0&id=6d9b4200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9b4200",
  null
  
)

export default component.exports